import { render } from "./OptionItem.vue?vue&type=template&id=0f0b026d&scoped=true"
import script from "./OptionItem.vue?vue&type=script&lang=js"
export * from "./OptionItem.vue?vue&type=script&lang=js"

import "./OptionItem.vue?vue&type=style&index=0&id=0f0b026d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0b026d"]])

export default __exports__